import TokenChecker from './helpers/TokenChecker';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import QuizDetail from './pages/quiz/quizeDetails';
import QuizeAttempt from './pages/quiz/quizeAttempt';
import QuizContainer from './containers/QuizContainer';

function App() {
  return (
    <div className="App">
      <TokenChecker/>
      <BrowserRouter>
        <QuizContainer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
